<template>
  <div class="wrap-wide" v-if="configureCopy">
    <div class="fn-guide">
      <div class="fn-guide-list">
        <ul>
          <li @click="pageBack">
            <i class="fa-chevron-left"></i>
            <span>返回</span>
          </li>
        </ul>
        <ul v-for="(item, menuindex) in menuList" :key="menuindex">
          <li
            v-for="subitem in item"
            :key="subitem.index"
            @click="menuSelect(subitem.index)"
            :class="{
              active: menuActiveTab == subitem.index,
            }"
          >
            <i :class="subitem.class"></i>
            <span>{{ subitem.title }}</span>
          </li>
        </ul>
        <i
          class="circle"
          :style="{
            top: `${
              25 +
              50 * menuActiveTab +
              (menuActiveTab > menuList[0].length - 1
                ? menuActiveTab > menuList[1].length + menuList[0].length - 1
                  ? 20
                  : 10
                : 0)
            }px`,
          }"
        ></i>
      </div>
    </div>
    <div class="fn-config">
      <div
        class="side"
        :style="{
          display: isShowTeach ? 'block' : '',
        }"
      >
        <div class="teach-box" @click.stop>
          <i class="close" @click="isShowTeach = false"></i>
          <div class="name">{{ configMainData[menuActiveTab].title }}</div>
          <el-radio-group v-model="teachActive">
            <el-radio-button
              label="demo"
              :disabled="!configMainData[menuActiveTab].demo"
              >实景演示</el-radio-button
            >
            <el-radio-button label="video">视频教程</el-radio-button>
          </el-radio-group>
          <div class="tabview">
            <div
              class="view"
              :class="{
                show: teachActive == 'video',
              }"
            >
              <video
                class="pc-block"
                :src="configMainData[menuActiveTab].pcVideo"
                poster="../assets/pic/video-sell.jpg"
                preload="meta"
                controls="controls"
              ></video>
              <video
                class="mb-block"
                :src="configMainData[menuActiveTab].mbVideo"
                poster="../assets/pic/video-sell.jpg"
                preload="meta"
                controls="controls"
              ></video>
            </div>
            <div
              class="view"
              :class="{
                show: teachActive == 'demo',
              }"
            >
              <div
                class="demo"
                v-html="configMainData[menuActiveTab].demo"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="collapse">
          <div
            class="hd"
            :class="{
              fold: !configMainShow['account'],
            }"
            @click="configMainShow['account'] = !configMainShow['account']"
          >
            <div class="title-fix">
              <i class="fa-angle-down"></i>
              <span>场控配置</span>
              <i
                class="flag client"
                v-if="!isCloud()"
                @click.stop="
                  shoWDialogBuy(
                    featureList['cloud']['productKey'],
                    '云端挂机',
                    'cloud'
                  )
                "
              ></i>
            </div>
          </div>
          <div class="bd">
            <input-room-id
              ref="inputroomid"
              :configure="configure"
              :currentConfigCopy="configureCopy"
              :ticket="ticket"
              :isCloud="isCloud()"
              @saveCompleted="saveCompleted"
              @roomChange="roomChange"
            ></input-room-id>

            <account-login
              slot="reference"
              :isCloud="isCloud()"
              :configure="configure"
              :roomId="
                configure.global.liveRoomName_config
                  ? configure.global.liveRoomUrl
                  : ''
              "
              :ticket="ticket"
              ref="accountlogin"
              @startRobotConfirm="startRobotConfirm"
              @savechange="savechange"
              @startRobot="startRobot"
              @loginStatusChange="loginStatusChange"
              @openElectronRobot="openElectronRobot"
            ></account-login>
          </div>
        </div>
        <config-welcome
          ref="welcome"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          :accountList="accountList"
          :giftSelectOptions="giftSelectOptions"
          :ticket="ticket"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @checkEmpty="checkEmpty"
          @toggleEnable="toggleEnable"
          @listLengthSave="listLengthSave"
        ></config-welcome>
        <config-gift-tks
          ref="giftTks"
          :configure="configure"
          :featureList="featureList"
          :accountList="accountList"
          :configMainShow="configMainShow"
          :giftSelectOptions="giftSelectOptions"
          :ticket="ticket"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @checkEmpty="checkEmpty"
          @toggleEnable="toggleEnable"
        ></config-gift-tks>
        <config-guide
          ref="guide"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @checkEmpty="checkEmpty"
          @toggleEnable="toggleEnable"
        ></config-guide>
        <config-auto-reply
          ref="autoReply"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @toggleEnable="toggleEnable"
          @removeTag="removeTag"
          @addTag="addTag"
        ></config-auto-reply>
        <config-ai-chat
          ref="AIChat"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @toggleEnable="toggleEnable"
        ></config-ai-chat>
        <config-read-text
          ref="readText"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          :ticket="ticket"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @toggleEnable="toggleEnable"
        ></config-read-text>
        <config-auto-ban
          ref="autoBan"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          :giftSelectOptions="giftSelectOptions"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @toggleEnable="toggleEnable"
          @removeTag="removeTag"
          @addTag="addTag"
        ></config-auto-ban>
        <config-key-person
          ref="keyPerson"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          :ticket="ticket"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @toggleEnable="toggleEnable"
          @checkEmpty="checkEmpty"
        ></config-key-person>
        <config-wx-push
          ref="wxPush"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          :ticket="ticket"
          :giftSelectOptions="giftSelectOptions"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @toggleEnable="toggleEnable"
          @checkEmpty="checkEmpty"
        ></config-wx-push>
        <config-beg-gift
          ref="begGift"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @toggleEnable="toggleEnable"
          @checkEmpty="checkEmpty"
        ></config-beg-gift>
        <config-guess-num
          ref="guessNum"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          :guessGameGiftOptions="guessGameGiftOptions"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @toggleEnable="toggleEnable"
        ></config-guess-num>
        <config-guess-province
          ref="guessProvince"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          :guessGameGiftOptions="guessGameGiftOptions"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @toggleEnable="toggleEnable"
        ></config-guess-province>
        <config-duty
          ref="duty"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @toggleEnable="toggleEnable"
          @checkEmpty="checkEmpty"
        ></config-duty>
        <config-big-data
          ref="bigData"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          :ticket="ticket"
          :privateCount="privateCount"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @toggleEnable="toggleEnable"
          @checkEmpty="checkEmpty"
        ></config-big-data>
        <config-private-letter
          v-if="menuList[2][0].index == 16"
          ref="privateLetter"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          :ticket="ticket"
          :privateCount="privateCount"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @toggleEnable="toggleEnable"
          @checkEmpty="checkEmpty"
        ></config-private-letter>
        <config-global
          ref="global"
          :configure="configure"
          :featureList="featureList"
          :configMainShow="configMainShow"
          @shoWDialogBuy="shoWDialogBuy"
          @showFunctionalRenewal="showFunctionalRenewal"
          @resetDefault="resetDefault"
          @toggleEnable="toggleEnable"
          @roomUrlInputFocus="roomUrlInputFocus"
        ></config-global>
      </div>
    </div>
    <div class="foot">
      <i class="btn-teach fa-book" @click="isShowTeach = true"></i>
      <i class="btn-gotop fa-angle-up" @click="scrollToTop"></i>
      <el-button
        :type="isChange ? 'danger' : 'primary'"
        icon="fa-save"
        @click="save"
        >{{ isChange ? "保存配置（有改动）" : "保存配置（未改动）" }}</el-button
      >
    </div>
    <pay-box
      ref="dialogpay"
      :ticket="ticket"
      @dialogClose="dialogPayClose"
      @payCompleted="payCompleted"
    ></pay-box>

    <div
      class="pop mask"
      :style="{
        display: isShowFunctionalRenewal ? 'block' : 'none',
      }"
      @click="isShowFunctionalRenewal = false"
    >
      <div class="box renew-box" @click.stop>
        <div class="title">
          续费
          <i class="close" @click="isShowFunctionalRenewal = false"></i>
        </div>
        <renew-box
          ref="renewbox"
          @orderPayShow="orderPayShow"
          :ticket="ticket"
        ></renew-box>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from "@/components/Editor";
import {
  getConfig,
  updateConfig,
  userInfo,
  getFeatureList,
  getUserRobots,
  getOrderPags,
  getWechatSdk,
  createWechatPay,
  createWechatPayOrder,
  getFeatureWords,
  consumeFCode,
  getFCode,
  checkFcodeOrder,
  getRoomName,
  getGiftinfo,
  getPrivateCount,
} from "@/api/index";
import { getCookie, removeCookie, getQueryString } from "@/utils/query";
import { deepObjectMerge } from "@/utils/object";
import accountLogin from "@/components/accountLogin";
import inputRoomId from "@/components/inputRoomId";
import configWelcome from "@/components/configWelcome";
import configGiftTks from "@/components/configGiftTks";
import configGuide from "@/components/configGuide";
import configAutoReply from "@/components/configAutoReply";
import configAiChat from "@/components/configAiChat";
import configReadText from "@/components/configReadText";
import configAutoBan from "@/components/configAutoBan";
import configKeyPerson from "@/components/configKeyPerson";
import configWxPush from "@/components/configWxPush";
import configBegGift from "@/components/configBegGift";
import configGuessNum from "@/components/configGuessNum";
import configGuessProvince from "@/components/configGuessProvince";
import configDuty from "@/components/configDuty";
import configBigData from "@/components/configBigData";
import configPrivateLetter from "@/components/configPrivateLetter";
import configGlobal from "@/components/configGlobal";
import payBox from "@/components/payBox";
import renewBox from "@/components/renewBox";
import { Message } from "element-ui";
import giftSelectOptions from "@/assets/js/giftSelectOptions.json";
import guessGameGiftOptions from "@/assets/js/guessGameGiftOptions.json";
import { mapState, mapActions } from "vuex";
import { scrollAnimation } from "@/utils/scroll.js";
import { commonFuc } from "@/mixins/commonFuc";
let collapse = [];
let inputRoomUrlTimer = null;
window.canRun = true;

export default {
  mixins: [commonFuc],
  data() {
    return {
      FCode: "",

      //菜单相关
      menuList: [
        [
          {
            title: "场控配置",
            href: "account",
            class: "fa-user-circle-o",
            index: 0,
            state: [],
          },
          {
            title: "来宾欢迎",
            href: "welcome",
            class: "fa-smile-o",
            index: 1,
            state: [],
          },
          {
            title: "礼物答谢",
            href: "giftTks",
            class: "fa-rocket",
            index: 2,
            state: [],
          },
          {
            title: "定时引导",
            href: "guide",
            class: "fa-history",
            index: 3,
            state: [],
          },
          {
            title: "智能答复",
            href: "autoReply",
            class: "fa-comments-o",
            index: 4,
            state: [],
          },
          {
            title: "AI 互动",
            href: "AIChat",
            class: "fa-reddit-alien",
            index: 5,
            state: [],
          },
          {
            title: "语音播报",
            href: "readText",
            class: "fa-volume-up",
            index: 6,
            state: [],
          },
          {
            title: "自动封禁",
            href: "autoBan",
            class: "fa-ban",
            index: 7,
            state: [],
          },
          {
            title: "大哥名单",
            href: "keyPerson",
            class: "fa-user-secret",
            index: 8,
            state: [],
          },
          {
            title: "微信推送",
            href: "wxPush",
            class: "fa-weixin",
            index: 9,
            state: [],
          },
        ],
        [
          {
            title: "智能狗",
            href: "begGift",
            class: "fa-gift",
            index: 10,
            state: [],
          },
          {
            title: "猜点数",
            href: "guessNum",
            class: "fa-sort-numeric-asc",
            index: 11,
            state: [],
          },
          {
            title: "猜省会",
            href: "guessProvince",
            class: "fa-map-marker",
            index: 12,
            state: [],
          },
          {
            title: "下播值守",
            href: "duty",
            class: "fa-plug",
            index: 13,
            state: [],
          },
          // {
          //   title: "私信作业",
          //   href: "privateLetter",
          //   class: "fa-paper-plane",
          //   index: 13,
          //   state: [],
          // },
        ],
        [
          {
            title: "其他配置",
            href: "global",
            class: "fa-ellipsis-h",
            index: 15,
            state: [],
          },
        ],
      ],
      menuActiveTab: 0,
      configMainData: require("@/assets/js/configMainData.json"),
      // 教学TAB选择
      teachActive: "demo",
      isShowTeach: false,
      tableData: [],
      options: [
        {
          value: "0",
          label: "1个月",
        },
        {
          value: "1",
          label: "3个月（+送30天）",
        },
        {
          value: "2",
          label: "1年（+送150天）",
        },
      ],
      //配置数据
      configure: null,
      features: null,
      configureCopy: "",
      //句式

      isShowFunctionalRenewal: false, //是否展示功能续费弹窗
      featureList: null, // 功能商品列表
      isChange: false, //是否修改配置
      isFirstGetConfig: true, //第一次拉取配置
      isFirstBuyDuty: false,
      payPkeyName: "",
      // 折叠面板
      configMainShow: {
        account: true,
        welcome: true,
        giftTks: true,
        guide: true,
        autoReply: true,
        AIChat: true,
        readText: true,
        autoBan: true,
        keyPerson: true,
        wxPush: true,
        begGift: true,
        guessNum: true,
        guessProvince: true,
        duty: true,
        bigData: true,
        privateLetter: true,
        global: true,
      },
      giftSelectOptions: giftSelectOptions,
      guessGameGiftOptions: guessGameGiftOptions,
      FCodeArray: [],
      accountList: {},
      ticket: "",
      robotLabel: "",
      selRobotLabel: "",
      // 通知识别
      isCurrentNotify: false,
      isFirstAddNotify: true,
      // 私信条数信息
      privateCount: {},
    };
  },
  computed: {
    ...mapState({
      isPC: (state) => state.isPC,
      isWeixin: (state) => state.isWeixin,
      video: (state) => state.video,
      isElectron: (state) => state.isElectron,
      robotList: (state) => state.robotList,
      user: (state) => state.user,
      cloud: (state) => state.cloud,
    }),
  },
  watch: {
    tableData: {
      handler: function (val, oldVal) {
        let count = 0;
        val.forEach((val) => {
          if (val.checked) {
            count++;
          }
        });
      },
      deep: true,
    },
    accountList: {
      handler: function (val, oldVal) {
        // this.sendConfigChange();
      },
      deep: true,
    },
    configure: {
      handler: function (val, oldVal) {
        if (this.isFirstGetConfig) {
          return;
        }
        if (JSON.stringify(val) !== this.configureCopy) {
          this.isChange = true;
        } else {
          this.isChange = false;
        }
      },
      deep: true,
    },
    robotList(val) {
      this.$emit("updateRobotList", val);
    },
    isChange(val) {
      if (val) {
        window.onbeforeunload = (e) => {
          if (this.isElectron) {
            this.$confirm(`配置尚未保存，是否保存配置？`, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                // TODO
                this.save();
              })
              .catch(() => {
                this.savechange();
              });
          }
          e.returnValue = false;
        };
      } else {
        window.onbeforeunload = null;
      }
    },
    menuActiveTab(val) {
      if (!this.configMainData[val].demo) {
        this.teachActive = "video";
      } else {
        this.teachActive = "demo";
      }
    },
    configMainShow: {
      handler: function (val, oldVal) {
        localStorage.setItem(this.ticket, JSON.stringify(this.configMainShow));
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "updateRobotList",
      "updateUser",
      "changeLoadingStatus",
      "updateClouduser",
    ]),
    isAccountExpire(timestamp) {
      let timeStamp = parseInt((+new Date() - timestamp) / 86400000) >= 7;
      if (timeStamp) {
        return true;
      } else {
        return false;
      }
    },
    addTag(list, evt) {
      if (list.indexOf(evt.target.value) != -1) {
        this.$message.warning("该关键词已存在");
        evt.target.value = "";
        return;
      }
      if (evt.target.value) {
        list.push(evt.target.value);
        evt.target.value = "";
      }
    },
    removeTag(list, index) {
      list.splice(index, 1);
    },
    toggleEnable(value, name) {
      if (this.configure[value].enable) {
        this.$confirm(`确认关闭${name}功能?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.configure[value].enable = false;
          })
          .catch(() => {});
      } else {
        this.$confirm(`确认打开${name}功能?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.configure[value].enable = true;
          })
          .catch(() => {});
      }
    },
    resetDefault(title, dataName) {
      this.$confirm(`确认要将「${title}」恢复默认嘛?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.configure[dataName] = JSON.parse(
            this.featureList[dataName].defaultData
          );
          if (dataName == "global") {
            this.configure["autoFeed"] = JSON.parse(
              this.featureList["autoFeed"].defaultData
            );
          }
          if (dataName == "giftTks") {
            this.$refs.giftTks.subscribeFormat();
          }
          if (dataName == "welcome") {
            this.$refs.welcome.whiteidConFormat();
          }
          if (dataName == "readText") {
            this.$refs.readText.broadcastCommonDetailFormat();
          }
          if (dataName == "keyPerson") {
            this.configure.welcome.welcomeBrother = JSON.parse(
              this.featureList.welcome.defaultData
            ).welcomeBrother;
            // this.$refs.keyPerson.keyPersonFormat();
          }
          if (dataName == "autoBan") {
            this.configure.blacklist = JSON.parse(
              this.featureList.blacklist.defaultData
            );
          }
          this.$message.success("恢复默认配置成功");
        })
        .catch((e) => {});
    }, //  恢复默认
    startRobotConfirm(type = "login") {
      if (this.cloud.user && this.configure.global.liveRoomUrl) {
        this.$confirm(
          `${type == "login" ? "登录成功" : "保存配置成功"}！立即启动机器人?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            // TODO
            this.startRobot();
          })
          .catch((e) => {
            this.$message({
              type: "info",
              message: "请稍后到机器人列表中启动",
            });
          });
      }
    },
    startRobot(json) {
      if (!this.configure.global.liveRoomUrl) {
        return;
      }
      this.accountList = localStorage["accountList"]
        ? JSON.parse(localStorage["accountList"])
        : {};
      if (this.isCloud()) {
        this.$refs.accountlogin.cloudStart();
      } else {
        if (this.isElectron) {
          if (
            this.isAccountExpire(
              this.accountList[this.ticket]
                ? this.accountList[this.ticket].timestamp
                : 0
            )
          ) {
            Message({
              showClose: true,
              message: `您的场控虎牙号登录授权已过期，请重新登录。`,
              type: "error",
            });
            return;
          }
          this.openElectronRobot();
        } else {
          this.$message.warning(
            "启动失败，电脑版机器人请在小虎弟客户端内启动。"
          );
        }
      }
    },
    async openElectronRobot(json = null) {
      if (this.configure.global.liveRoomUrl) {
        let ticket = json ? json.ticket : this.ticket;
        const loading = this.$loading({
          lock: true,
          text: "机器人启动中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const restartRes = await manager.restartLocalRobot(
          ticket,
          `https://www.huya.com/${this.configure.global.liveRoomUrl}`
        );
        if (restartRes.code == 0) {
          Message({
            showClose: true,
            message: `重启成功`,
            type: "success",
          });
          this.accountList[ticket].user.status = 1;
        } else {
          const res = await manager.startLocalRobot({
            ticket: ticket,
            cookies: json ? json.cookie : this.accountList[ticket].cookies,
            url: `https://www.huya.com/${this.configure.global.liveRoomUrl}`,
            account: this.user.account,
            name: this.robotLabel,
            show: false,
          });
          if (res.code == 0) {
            Message({
              showClose: true,
              message: `启动成功`,
              type: "success",
            });
            this.accountList[ticket].user.status = 1;
          } else {
            Message({
              showClose: true,
              message: res.message,
              type: "error",
            });
            this.accountList[ticket].user.status = 0;
          }
          localStorage["accountList"] = JSON.stringify(this.accountList);
          this.$refs.accountlogin.getCloudStatus();
        }
        loading.close();
        this.sendConfigChange();
      } else {
        this.$message({
          title: "提示",
          message: "请填写房间号",
          type: "error",
          duration: 2000,
        });
      }
    },
    save() {
      let isShowAIChatMes = false;
      this.configure.AIChat.symbolList.forEach((inputValue) => {
        if (
          !!~inputValue.indexOf("/{") ||
          !!~inputValue.indexOf("{") ||
          !!~inputValue.indexOf("/")
        ) {
          isShowAIChatMes = true;
        }
      });
      if (isShowAIChatMes) {
        return this.$message({
          showClose: true,
          message: "互动符号不能含有'/'或'{'符号",
          type: "error",
        });
      }
      if (
        (!this.configure.global.liveRoomName_config &&
          this.configure.global.liveRoomUrl) ||
        (this.configure.global.liveRoomName_config &&
          !this.configure.global.liveRoomUrl) ||
        (this.configure.global.liveRoomName_config &&
          this.configure.global.liveRoomUrl &&
          this.configure.global.liveRoomName_config == "无此房间")
      ) {
        return;
      }
      if (
        this.configure.autoBan.autoCancelBan &&
        !this.configure.autoBan.autoCancelBanGiftContentList.length
      ) {
        return this.$message({
          dangerouslyUseHTMLString: true,
          type: "error",
          message: "自动解封灯牌内容不能为空",
        });
      }
      updateConfig({
        configure: JSON.stringify(this.configure),
        ticket: this.ticket,
      }).then((res) => {
        if (res.code == 0) {
          // this.$message.success("保存配置成功");
          this.savechange();
          if (this.isElectron) {
            this.startRobotConfirm("save");
            this.sendConfigChange();
          } else {
            if (this.cloud.user && this.configure.global.liveRoomUrl) {
              // if (this.user.platform == "cloud") {
              if (this.featureList["cloud"].isBuy) {
                this.$confirm("保存配置成功！立即启动机器人?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    // TODO
                    this.$refs.accountlogin.cloudStart();
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "请稍后到机器人列表中启动",
                    });
                  });
              } else {
                //立即更新配置？请刷新直播间，重启机器人
                this.$message.success("立即更新配置？请刷新直播间，重启机器人");
              }
            }
            this.sendDataChange();
          }
        }
      });
    }, // 保存配置
    savechange() {
      this.isChange = false;
      this.configureCopy = JSON.stringify(this.configure);
    },
    saveCompleted() {
      this.savechange();
      if (this.isElectron) {
        this.sendConfigChange();
      } else {
        this.sendDataChange();
      }
      this.$refs.accountlogin.checkAccountType((accountTypeRes) => {
        this.accountList[this.ticket].user.accountType =
          accountTypeRes.code == 0 ? accountTypeRes.data.data : -1;
        this.accountList[this.ticket] = this.accountList[this.ticket];
        localStorage["accountList"] = JSON.stringify(this.accountList);
        this.updateClouduser(
          this.accountList[this.ticket] ? this.accountList[this.ticket] : null
        );
      });
    },
    roomChange() {
      this.$refs.welcome.signInStatusChange();
    },
    listLengthSave() {
      this.configureCopy = JSON.stringify(this.configure);
      this.isChange = false;
    },
    getUserInfo() {
      userInfo(null, { notify: false }).then((res) => {
        this.updateUser(res.data);
      });
    },
    checkEmpty(list, index) {
      if (index === undefined) {
        if (String(list).trim() == "") {
          list = "";
        }
      } else {
        if (String(list[index]).trim() == "") {
          list.splice(index, 1);
        }
      }
    }, // 列表被清空时
    showFunctionalRenewal(bool) {
      //展示功能续费弹窗
      this.isShowFunctionalRenewal = bool;
      // this.$router.replace({
      //   path: "/robotManager",
      //   query: {
      //     openFuc: "shopping",
      //   },
      // });
    },
    getRoomName(roomid) {
      return getRoomName(
        {
          roomId: roomid,
        },
        { notify: false }
      ).then((res) => {
        if (res.code == 0) {
          return res.data;
        }
        if (res.code == 500) {
          this.$message({
            dangerouslyUseHTMLString: true,
            type: "error",
            message:
              '<strong>找不到这个主播</strong><p style="margin-top: 5px;">请确认房间号是否正确</p>',
          });
        }
      });
    },
    setTableData() {
      if (localStorage[this.ticket]) {
        let configMainShow = JSON.parse(localStorage[this.ticket]);
        Object.assign(this.configMainShow, configMainShow);
      }
    },
    getDefaultData() {
      this.setTableData();
      this.getConfig();
    },
    dialogPayClose() {
      this.$refs.dialogpay.hideDialog();
    },
    shoWDialogBuy(key, name, videoKey, descType = "") {
      this.$refs.dialogpay.showDialogOfBuy(key, descType);
    },
    payCompleted(fcode, pkey = "") {
      this.payPkeyName = pkey;
      if (fcode && fcode.length) {
        this.FCodeArray = fcode;
        this.actionFCodeArray();
      } else {
        this.getConfigData();
      }
    },
    getConfig() {
      getConfig(
        {
          ticket: this.ticket,
        },
        { notify: false }
      ).then((res) => {
        if (res.code == 0) {
          const configure = res.data.configure;
          let d = JSON.parse(configure);
          if(d.global && !Object.prototype.hasOwnProperty.call(d.global,'enableBox')){
                d.global.enableBox =true
          }
          if (d.autoReply && !d.autoReply.football) {
            d.autoReply.football = {
              pushEnable: false,
              codeEnable: true,
            };
          }
          if (this.configure == null) {
            this.configure = d;
          } else {
            Object.assign(this.configure, d);
          }
          this.features = res.data.features;
          this.getPrivateCount();
          this.getFeaturList();
        }
      });
    },
    getConfigData(type = "") {
      getUserRobots({ notify: false }).then(async (res) => {
        if (res.code === 0) {
          // let robotList = []
          for (let index = 0; index < res.data.robots.length; index++) {
            let val = res.data.robots[index];
            // let huyaUserName = await this.getRoomName(val.roomId)
            // robotList.push({
            //   label: `${index + 1}号机器人`,
            //   name: `${index}`,
            //   ticket: val.ticket,
            //   value: `${index}`,
            //   huyaUserName
            // })
            if (this.ticket == val.ticket) {
              this.robotLabel = `${index + 1}号机器人`;
              // this.selRobotLabel = `${index + 1}号机器人${
              //   huyaUserName ? `-${huyaUserName}` : ''
              // }`
            }
          }
          if (/duty/i.test(this.payPkeyName) && !this.featureList.duty.isBuy) {
            this.isFirstBuyDuty = true;
          }
          // this.updateRobotList(robotList)
          this.getUserInfo();
          this.getDefaultData();
        }

        if (res.code == -2050) {
          localStorage.removeItem("sid");
          this.$router.replace({
            path: "/login",
            query: {
              redirect: "config",
              ticket: this.ticket,
            },
          });
        }
      });
    },
    getFeaturList() {
      getFeatureList(null, { notify: false }).then((res) => {
        if (res.code == 0) {
          const featureList = res.data.featureList;
          this.featureList = {};
          featureList.forEach((val, index) => {
            if (val.jsonField == "global") {
              let defaultData = JSON.parse(val.defaultData);
              defaultData.liveRoomUrl = this.configure.global.liveRoomUrl;
              defaultData.liveRoomName_config =
                this.configure.global.liveRoomName_config;
              defaultData.anchorNick = this.configure.global.anchorNick;
              val.defaultData = JSON.stringify(defaultData);
            }
            if (val.jsonField == "keyPerson") {
              let defaultData = JSON.parse(val.defaultData);
              defaultData.list = this.configure.keyPerson.list;
              val.defaultData = JSON.stringify(defaultData);
            }
            this.featureList[val.jsonField] = val;
            this.featureList[val.jsonField].isBuy = this.features[val.jsonField]
              ? true
              : false;
            this.featureList[val.jsonField].timeRemaining = Math.ceil(
              (this.features[val.jsonField] * 1000 - +new Date()) / 86400000
            );
            if (this.configure[val.jsonField]) {
              //   this.configure[val.jsonField] = deepObjectMerge(
              //     JSON.parse(val.defaultData),
              //     this.configure[val.jsonField]
              //   );
            } else {
              this.$set(
                this.configure,
                val.jsonField,
                deepObjectMerge({}, JSON.parse(val.defaultData))
              );
              // this.configure[val.jsonField] = Object.assign({}, JSON.parse(val.defaultData));
            }
            if (index + 1 == featureList.length) {
              setTimeout(() => {
                // this.featureList['account'].isBuy = true
                // this.featureList['global'].isBuy = true
                this.isFirstGetConfig = false;
                this.pageReady();
              }, 0);
            }
          });
          this.getGiftinfo();
          if (!this.configure.cloud.liveRoomUrl) {
            this.configure.cloud.liveRoomUrl =
              this.configure.global.liveRoomUrl;
          }
          if (
            !this.configure.AIChat.symbolList.length &&
            !this.configure.AIChat.symbol.length
          ) {
            // this.configure.AIChat.symbol = "@";
            this.configure.AIChat.symbolList.push("@");
          }
          if (
            !this.configure.AIChat.symbolList.length &&
            this.configure.AIChat.symbol.length
          ) {
            this.configure.AIChat.symbolList.push(this.configure.AIChat.symbol);
            this.configure.AIChat.symbol = "";
          }
          if (this.configure.autoBan.autoCancelBanGiftContent) {
            this.configure.autoBan.autoCancelBanGiftContentList.push(
              this.configure.autoBan.autoCancelBanGiftContent
            );
            this.configure.autoBan.autoCancelBanGiftContent = "";
          }
          if (this.isFirstBuyDuty) {
            this.configure.duty.welcome = this.configure.welcome.enable;
            this.configure.duty.giftTks = this.configure.giftTks.enable;
            this.configure.duty.guide = this.configure.guide.enable;
            this.configure.duty.autoReply = this.configure.autoReply.enable;
            this.configure.duty.AIChat = this.configure.AIChat.enable;
            this.configure.duty.autoBan = this.configure.autoBan.enable;
            this.configure.duty.begGift = this.configure.begGift.enable;
            this.isFirstBuyDuty = false;
            this.save();
          }
          this.configureCopy = JSON.stringify(this.configure);
          // this.isFirstGetConfig = false;
        }
      });
    },
    getGiftinfo() {
      getGiftinfo({
        roomId: this.configure.global.liveRoomUrl,
      }).then((res) => {
        if (res.code == 0) {
          let giftSelectOptions = [
            {
              label: "礼物",
              options: [],
            },
          ];
          let guessGameGiftOptions = [
            {
              label: "礼物",
              options: [],
            },
          ];
          if (res.data && res.data.length) {
            res.data.forEach((val) => {
              giftSelectOptions[0].options.push({
                value: val.gift_name,
                label: val.gift_name,
                id: val.gift_id,
              });
              if (!~val.gift_name.indexOf("虎粮")) {
                guessGameGiftOptions[0].options.push({
                  value: val.gift_name,
                  label: val.gift_name,
                  id: val.gift_id,
                });
              }
            });
          }
          this.giftSelectOptions = giftSelectOptions;
          this.guessGameGiftOptions = guessGameGiftOptions;
        }
      });
    },
    actionFCodeArray() {
      this.FCodeArray.forEach((val, index) => {
        setTimeout(() => {
          this.FCode = val.fcode;
          this.actionFCode();
          console.log(index, this.FCodeArray);
          if (index == this.FCodeArray.length - 1) {
            this.FCodeArray = [];
            this.getConfigData();
          }
        }, 100);
      });
    },
    actionFCode() {
      if (this.FCode.length != 32 && this.FCode.length != 10) {
        this.$message({
          dangerouslyUseHTMLString: true,
          type: "error",
          message:
            '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
        });
        return;
      }
      if (this.FCode) {
        consumeFCode({
          fcode: this.FCode,
          ticket: this.ticket,
        }).then((res) => {
          if (res.code == 0) {
            getFCode({
              fcode: this.FCode,
            }).then((resp) => {
              if (resp.code === 0) {
              }
              if (JSON.parse(getCookie("F_CODE"))) {
                this.$message({
                  type: "success",
                  dangerouslyUseHTMLString: true,
                  message: `已为您自动使用F码：<br/>${
                    JSON.parse(getCookie("F_CODE")).code
                  }`,
                });
                removeCookie("F_CODE");
              }
            });
            this.getDefaultData();
          } else {
            if (res.code == 20004) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码错误</strong><p style="margin-top: 5px;">F码错误请重新输入</p>',
              });
              // '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
            }
            if (res.code == 20005) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是公会版F码，请下载公会版使用</p>',
              });
            }
            if (res.code == 20006) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">新手体验码每个账号只能使用一张</p>',
              });
            }
            if (res.code == 20007) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是单功能F码，无法用于新增机器人</p>',
              });
            }
            if (res.code == 20008) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已被使用，如有疑问，请联系客服</p>',
              });
            }
            if (res.code == 20015) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验码仅限原账号使用</p>',
              });
            }
            if (res.code == 20016) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已过期，体验卡请在24小时内使用</p>',
              });
            }
            if (res.code == 20017) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验卡仅限给发码机器人使用</p>',
              });
            }
            if (JSON.parse(getCookie("F_CODE"))) {
              removeCookie("F_CODE");
            }
          }
        });
      } else {
        Message({
          showClose: true,
          message: "请输入F码",
        });
      }
    },
    confirmConsumeFCode() {
      this.$confirm(
        `检查到您电脑上有一张未使用的F码：<input id="copy_text" value="${this.FCode}" style="opacity:0;visible:hidden;width:10px;"/><br/>
      ${this.FCode}<el-button type="text" onclick="
        var copyText = document.getElementById('copy_text');
        copyText.select();
        document.execCommand('copy');
      " style="cursor:pointer;margin-left:10px;">复制</el-button>`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确认使用",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.actionFCode();
        })
        .catch((action) => {
          removeCookie("F_CODE");
        });
    },
    checkFcodeOrder(orderId) {
      checkFcodeOrder(
        {
          orderId: orderId,
        },
        { notify: false }
      ).then((res) => {
        if (res.code === 0) {
          if (res.data.paid) {
            this.FCodeArray = res.data.fcodes;
            this.actionFCodeArray();
            // this.confirmConsumeFCode();
          }
        }
      });
    },
    sendConfigChange() {
      if (!this.isFirstGetConfig) {
        if (window.electron) {
          window.electron.ipcRenderer.send("configChange");
        } else {
          if (this.isElectron) {
            setTimeout(() => {
              this.sendConfigChange();
            }, 1000);
          }
        }
      }
    },
    sendDataChange() {
      this.isCurrentNotify = true;
      setTimeout(() => {
        this.isCurrentNotify = false;
      }, 1000);
      this.$configListen.notify();
    },
    scrollConfigPage() {
      if (!window.canRun) {
        return;
      }
      window.canRun = false;
      setTimeout(() => {
        let top = document.body.scrollTop || document.documentElement.scrollTop;
        for (
          let i =
            this.menuList[0].length +
            this.menuList[1].length +
            this.menuList[2].length;
          i > 0;
          i--
        ) {
          //倒叙缩减循环次数
          //js会对小数部分自动四舍五入，导致计算出现偏差，故+1解决
          if (collapse[i - 1] && top + 1 >= collapse[i - 1].offsetTop) {
            if (this.menuActiveTab != i - 1) {
              this.menuActiveTab = i - 1;
            }
            break;
          }
        }
        window.canRun = true;
      }, 0);
    },
    menuSelect(index) {
      if (window.scrollTimer) {
        clearTimeout(window.scrollTimer);
        window.scrollTimer = null;
      }
      window.canRun = false;
      this.menuActiveTab = index;
      scrollAnimation(
        document.documentElement.scrollTop,
        collapse[index].offsetTop
      );
    },
    scrollToTop() {
      if (window.scrollTimer) {
        clearTimeout(window.scrollTimer);
        window.scrollTimer = null;
      }
      window.canRun = false;
      this.menuActiveTab = 0;
      scrollAnimation(document.documentElement.scrollTop, 0);
    },
    pageReady() {
      collapse = document.querySelectorAll(".collapse");
      window.addEventListener("scroll", this.scrollConfigPage, true);
      if (!this.configMainData[this.menuActiveTab].demo) {
        this.teachActive = "video";
      }
      this.changeLoadingStatus(false);
    },
    pageBack() {
      this.$router.replace("/robotManager");
    },
    roomUrlInputFocus() {
      this.$refs.inputroomid.roomUrlInputFocus();
    },
    loginStatusChange(type = "") {
      this.accountList = localStorage["accountList"]
        ? JSON.parse(localStorage["accountList"])
        : {};
      this.$forceUpdate();
    },
    orderPayShow(json, orderpaytype = "normal") {
      let self = this;
      json.ticket = this.ticket;
      this.orderPayType = orderpaytype;
      if (this.isWeixin && !this.isPC) {
        createWechatPayOrder(json).then((res) => {
          if (res.code == 1000) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>创建订单失败</strong><p style="margin-top: 5px;">错误码「1000」，请联系客服</p>',
            });
          }
          if (res.code == 20001) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>商品不存在</strong><p style="margin-top: 5px;">错误码「20001」，请联系客服</p>',
            });
          }
          let orderId = res.data.orderId;
          createWechatPay({
            order_id: orderId,
          }).then((payData) => {
            if (payData.code == 70003) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>微信登录授权过期</strong><p style="margin-top: 5px;">请刷新，重新登录配置后台</p>',
              });
            }
            if (payData.code == 1000) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>创建公众号订单失败</strong><p style="margin-top: 5px;">错误码「1000」，请联系客服</p>',
              });
            }
            if (payData.code == 0) {
              let data = payData.data;
              wx.chooseWXPay({
                timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: data.paySign, // 支付签名
                success: function (res) {
                  // 支付成功后的回调函数
                  self.checkFcodeOrder(orderId);
                },
              });
            }
          });
        });
        return;
      }
      setTimeout(() => {
        this.$refs.dialogpay.showDialog(json);
      }, 0);
    },
    getPrivateCount() {
      getPrivateCount({
        ticket: this.ticket,
      }).then((res) => {
        if (res.code == 0) {
          this.privateCount = res.data;
          if (res.data.allow) {
            console.log(
              this.menuList[1],
              this.menuList[1][this.menuList[1].length - 1].href
            );
            if (
              this.menuList[1][this.menuList[1].length - 1].href ==
              "privateLetter"
            )
              return;
            this.menuList[1].push({
              title: "私信作业",
              href: "privateLetter",
              class: "fa-paper-plane",
              index: 15,
              state: [],
            });
            this.menuList[2][0].index = 16;
            this.configMainData.splice(15, 0, {
              stamp: "privateLetter",
              title: "私信作业",
              pcVideo:
                "https://huya-w10.huya.com/2011/290998782/1300/0d96d6052f92c65fa678d6506f8145b4.mp4",
              mbVideo:
                "https://huya-w10.huya.com/2011/290998782/1300/0d96d6052f92c65fa678d6506f8145b4.mp4",
              demo: "",
            });
            this.$forceUpdate();
          }
        }
      });
    },
  },
  components: {
    accountLogin,
    payBox,
    renewBox,
    inputRoomId,
    configWelcome,
    configGiftTks,
    configGuide,
    configAutoReply,
    configAiChat,
    configReadText,
    configAutoBan,
    configKeyPerson,
    configWxPush,
    configBegGift,
    configGuessNum,
    configGuessProvince,
    configDuty,
    configBigData,
    configPrivateLetter,
    configGlobal,
  },
  created() {
    this.getConfigData();
    if (!this.isElectron) {
      document.addEventListener("changed", () => {
        if (this.isFirstAddNotify) {
          this.isFirstAddNotify = false;
          return;
        }
        if (!this.isCurrentNotify && !this.isFirstGetConfig) {
          this.isFirstGetConfig = true;
          this.getConfigData();
        }
      });
    }
  },
  mounted() {
    this.changeLoadingStatus(true);
    this.accountList = localStorage["accountList"]
      ? JSON.parse(localStorage["accountList"])
      : {};
    this.ticket = this.$route.query.ticket;
    if (!this.ticket) {
      this.$router.replace({
        path: "/robotManager",
      });
    }
    let FcodeJson = JSON.parse(getCookie("F_CODE"));
    if (FcodeJson) {
      this.FCode = FcodeJson.code;
      setTimeout(() => {
        this.confirmConsumeFCode();
      }, 500);
    }
    let orderId = getQueryString("orderId");
    if (orderId) {
      setTimeout(() => {
        this.checkFcodeOrder(orderId);
      }, 500);
    }
    if (this.isWeixin) {
      getWechatSdk(
        {
          url: location.href,
        },
        { notify: false }
      ).then((res) => {
        let data = res.data;
        wx.config({
          debug: data.debug,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: data.jsApiList,
        });
      });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollConfigPage, true);
  },
};
</script>
